// extracted by mini-css-extract-plugin
export default {"panel":"Panel-module__panel__enSI-","opened":"Panel-module__opened__UE0s-","content":"Panel-module__content__Uy6+I"};